import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { whatsappLink } from "../data/site";

export default function WhatsAppFloat() {
    return (
        <motion.a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-float"
            aria-label="Contattaci su WhatsApp"
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 1.4, duration: 0.5, ease: [0.215, 0.61, 0.355, 1] }}
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.95 }}
            className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-wa text-white shadow-lg shadow-wa/30 transition-colors hover:bg-wa-dark"
        >
            <MessageCircle className="h-6 w-6" />
        </motion.a>
    );
}
